export default function Disclaimer (props) {
  return (
    <p className="wp-block-gds-lead-form__disclaimer" dangerouslySetInnerHTML={{__html: props.text}} />
  )
}